import { type AxiosRequestConfig } from 'axios';
import type { AxiosDataReturn, PaginatedResponse } from '../types/generic';
import api from './api-instance';
import { toast } from 'react-toastify';
import type {
  TEvent,
  TEventFormData,
  TEventStats,
  TEventStatus,
} from '../types/event';

export const eventsList = async (args?: AxiosRequestConfig<any>) => {
  try {
    const res = await api.get<AxiosDataReturn<PaginatedResponse<TEvent>>>(
      '/events/admin',
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error('Something went wrong', { toastId: 'api-error' });
    throw e;
  }
};

export const eventCreate = async (
  data: TEventFormData,
  args?: AxiosRequestConfig<any>
) => {
  try {
    const res = await api.post<AxiosDataReturn<TEvent>>(
      '/events/admin',
      data,
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error('Something went wrong', { toastId: 'api-error' });
    throw e;
  }
};

export const eventUpdate = async (
  id: string,
  data: Omit<TEvent, 'id' | 'createdAt' | 'updatedAt' | 'program'>,
  args?: AxiosRequestConfig<any>
) => {
  try {
    const res = await api.put<AxiosDataReturn<TEvent>>(
      `/events/admin/${id}`,
      data,
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error('Something went wrong', { toastId: 'api-error' });
    throw e;
  }
};

export const eventDelete = async (
  id: string,
  args?: AxiosRequestConfig<any>
) => {
  try {
    const res = await api.delete<AxiosDataReturn<null>>(
      `/events/admin/${id}`,
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error('Something went wrong', { toastId: 'api-error' });
    throw e;
  }
};

export const eventStatus = async (
  id: string,
  args?: AxiosRequestConfig<any>
) => {
  try {
    const res = await api.get<
      AxiosDataReturn<PaginatedResponse<TEventStatus, TEventStats>>
    >(`/events/admin/${id}/statuses`, args);
    return res?.data?.data;
  } catch (e) {
    toast.error('Something went wrong', { toastId: 'api-error' });
    throw e;
  }
};
